var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group-row',{attrs:{"form":_vm.form,"label":_vm.label,"name":"email","required":""}},[_c('form-input',{attrs:{"form":_vm.form,"name":"email","type":"email","disabled":_vm.disabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }